<header id="header" class="header fixed">
  <div
    class="navbar-top d-flex justify-content-between flex-lg-row flex-column"
  >
    <!-- Shimmer animation container -->
    <div class="shimmer-container"></div>

    <div class="current-menu info-left flex-fill">
      <div class="nav-button d-xl-none">
        <button
          (click)="toggleSidebar()"
          (keyup.enter)="toggleSidebar()"
          class="text-body navbar-toggler"
          [class.is-open]="sideBarvisible"
          type="button"
          aria-controls="navbarSupportedContent"
          [attr.aria-expanded]="sideBarvisible"
          aria-label="Toggle navigation"
        >
          <i class="fa-solid fa-lg" [class.fa-bars]="!sideBarvisible" [class.fa-xmark]="sideBarvisible" aria-hidden="true"></i>
        </button>
      </div>

      <div class="logo flex-fill d-sm-flex d-lg-block">
        <a [routerLink]="'/dashboard'" title="">
          <!-- Light Mode Logo  -->
          @if (!dark.value) {
            <img
              src="assets/images/ScanNinjaHorizontal-dark.png"
              alt="Scan Ninja"
              class="img-fluid"
            />
          }
          <!-- Dark Mode Logo  -->
          @if (dark.value) {
            <img
              src="assets/images/ScanNinjaHorizontal.png"
              alt="Scan Ninja"
              class="img-fluid"
            />
          }
        </a>
      </div>
      <!-- /.logo -->

      <!-- TODO Add This Search to the list  -->
      @if (false) {
        <div class="box-search">
          <form action="#" method="get" accept-charset="utf-8">
            <a (click)="openSearch()" (keypress)="openSearch()" tabindex="0"
              ><img src="assets/images/icon/search.png" alt="search icon"
            /></a>
            <input title="Form input"
              type="text"
              placeholder="Search Projects..."
              name="Search"
              class="form-control"
            />
          </form>
        </div>
      }
      <!-- /.box-search -->
    </div>
    <!-- /.current-menu -->

    <div class="account-info account-info my-4 d-none d-lg-block">
      @if (licenseLookupPending && (!mspAccount || !mspAccount.license_expiration_date)) {
        <i class="fa-solid fa-spinner fa-spin"></i>
      }
      @if (
        mspAccount && mspAccount.license_expiration_date && mspAccount.is_eval
      ) {
        <p>
          Account Expires:
          {{
            mspAccount.license_expiration_date * 1000 | date: "MMM d, y HH:mm"
          }}
          @if (mspAccount.is_eval) {
            <span class="text-info">( Eval Account ) </span>
          }
        </p>
        @if (!isExpiringSoon(mspAccount.license_expiration_date)) {
          <p class="text-end">
            @if (mspAccount.is_eval) {
              <a [routerLink]="['/dashboard', 'my-account', 'upgrade-plan']"
                >Upgrade Account</a
              >
            }
          </p>
        }
        @if (
          isExpiringSoon(mspAccount.license_expiration_date) &&
          remainingTime &&
          mspAccount.license_expiration_date
        ) {
          <p>
            Expires in:
            @if (remainingTime.hours > 0) {
              <span class="text-danger">{{ remainingTime.hours }} hours</span>
            }
            @if (remainingTime.hours > 0 && remainingTime.minutes > 0) {
              <span class="text-danger"> and </span>
            }
            @if (remainingTime.minutes > 0) {
              <span class="text-danger"
                >{{ remainingTime.minutes }} minutes</span
              >
            }
            @if (
              remainingTime.seconds > 0 &&
              remainingTime.hours === 0 &&
              remainingTime.minutes === 0
            ) {
              <span class="text-danger">
                and {{ remainingTime.seconds }} seconds</span
              >
            }
          </p>
          <p class="text-end">
            @if (!mspAccount.is_eval) {
              <a [routerLink]="['/dashboard', 'my-account']" fragment÷="billing"
                >Renew Now</a
              >
            }
          </p>
        }
      }
    </div>
    <div class="my-account">
      <ul class="info-right">

        <!-- Ninja Coins Widget -->
        <li class="sni-credits d-none d-xl-flex">
          <a
            class="sni-credits-link"
            [routerLink]="['/dashboard/company']"
            [fragment]="'sni-tokens'"
            [title]="creditSummary ? ('Coins: ' + ninjaCreditsService.formatCredits(creditSummary.totalAvailable) + ' available • ' + ninjaCreditsService.formatCredits(creditSummary.monthlyAllotment) + '/month included') : 'Coins'"
            aria-label="View Coins balance"
          >
            <i class="fas fa-coins" aria-hidden="true"></i>
            <div class="sni-credits-text">
              <div class="sni-credits-amount" [ngClass]="'text-' + getCreditColorClass()">
                @if (creditSummary) {
                  {{ ninjaCreditsService.formatCredits(creditSummary.totalAvailable) }}
                } @else {
                  &mdash;
                }
              </div>
              <div class="sni-credits-label">
                @if (creditSummary) {
                  {{ ninjaCreditsService.formatCredits(creditSummary.monthlyAllotment) }}/mo
                } @else {
                  Coins
                }
              </div>
            </div>
          </a>
        </li>
        @if (isDev) {
          <li class="setting">
            <!-- TODO Create this import file section for scan results -->
            <a
              class="waves-effect waves-teal"
              title=""
              [routerLink]="'/dashboard/scan-upload'"
              routerLinkActive="active"
              title="Upload Scan"
            >
              <i class="fa fa-file-import"></i>
            </a>
          </li>
        }

        <li class="setting">
          <a
            class="waves-effect waves-teal"
            [routerLink]="['/dashboard', 'ninja-scanners', 'create']"
            [queryParams]="{ mode: 'scan' }"
            title="Create Scan"
            aria-label="Create Scan"
          >
            <i class="fa fa-plus"></i>
          </a>
        </li>

        <!-- /.setting -->
        <li class="notification" [class.open]="showNotyMenu">
          <!-- Updated to show real notifications from services -->
          <a
            #notyButton
            class="waves-effect waves-teal icon"
            title="Notifications"
            (click)="showNotifications()"
            (keyup)="showNotifications()"
            tabindex="1"
          >
            <i
              class="fa fa-bell"
              [class.text-warning]="hasUnreadNotifications()"
            ></i>
            @if (getNotificationCount() > 0) {
              <span class="count">{{ getNotificationCount() }}</span>
            }
          </a>
          <div
            #notyMenu
            class="cyber-notification-panel"
            [class.active]="showNotyMenu"
          >
            <div class="cyber-panel-container">
              <div class="cyber-panel-header">
                <div class="d-flex align-items-center gap-2">
                  <i class="fa fa-bell cyber-panel-icon"></i>
                  <h6 class="cyber-panel-title">Notifications</h6>
                  <span class="cyber-count-badge">{{
                    getNotificationCount()
                  }}</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  @if (getNotificationCount() > 0) {
                    <button
                      type="button"
                      class="btn-cyber-clear"
                      title="Clear All"
                      (click)="clearAllNotifications()"
                    >
                      <i class="bi bi-trash"></i>
                      <span>Clear All</span>
                    </button>
                  }
                  <button
                    type="button"
                    class="cyber-close-btn"
                    aria-label="Close"
                    (click)="showNotifications()"
                    (keyup)="showNotifications()"
                    tabindex="0"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>

              <!-- No notifications message -->
              @if (getNotificationCount() === 0) {
                <div class="cyber-empty-state">
                  <div class="cyber-empty-icon">
                    <i class="fa fa-bell-slash"></i>
                  </div>
                  <div class="cyber-empty-content">
                    <p class="cyber-empty-title">No notifications</p>
                    <small class="cyber-empty-subtitle"
                      >You're all caught up!</small
                    >
                  </div>
                </div>
              }

              <!-- Notifications list -->
              @if (getNotificationCount() > 0) {
                <div class="cyber-notifications-list">
                  @for (
                    notification of notifications;
                    track trackByNotificationId(i, notification);
                    let i = $index
                  ) {
                    <div
                      class="cyber-notification-item"
                      [attr.data-notification-type]="notification.type"
                      [attr.data-level]="notification.level"
                    >
                      <div class="cyber-notification-content">
                        <!-- Notification header with type badge and timestamp -->
                        <div class="cyber-notification-header">
                          <span
                            class="cyber-type-badge"
                            [ngClass]="{
                              'type-system': notification.type === 'System',
                              'type-scan': notification.type === 'Scan',
                              'type-security': notification.type === 'Security',
                            }"
                          >
                            <i
                              class="cyber-type-icon"
                              [ngClass]="{
                                'fa fa-cog': notification.type === 'System',
                                'fa fa-satellite-dish': notification.type === 'Scan',
                                'fa fa-shield-alt':
                                  notification.type === 'Security',
                              }"
                            ></i>
                            {{ notification.type }}
                          </span>
                          <small class="cyber-timestamp">{{
                            getTimeAgo(notification.timestamp)
                          }}</small>
                        </div>

                        <!-- Notification body -->
                        <div class="cyber-notification-body">
                          @if (notification.title) {
                            <div class="cyber-notification-title">
                              <span [innerText]="notification.title"></span>
                            </div>
                          }
                          <div class="cyber-notification-message">
                            <span [innerText]="notification.message"></span>
                          </div>
                        </div>

                        <!-- Action buttons -->
                        <div class="cyber-notification-actions">
                          <button
                            type="button"
                            class="cyber-action-btn"
                            (click)="onNotificationClick(notification)"
                            title="View Details"
                          >
                            <i class="fa fa-external-link-alt"></i>
                            {{ notification.action?.label || "View Details" }}
                          </button>
                        </div>
                      </div>

                      <!-- Remove button -->
                      <div class="cyber-notification-remove">
                        <button
                          type="button"
                          class="cyber-remove-btn"
                          title="Remove notification"
                          (click)="removeNotification(notification)"
                          (keyup)="removeNotification(notification)"
                          tabindex="0"
                        >
                          <i class="bi bi-x"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <!-- /.dropdown-menu -->
        </li>
        <!-- /.notification -->
        <!-- User Profile Information  -->
        @if (userModel) {
          <li
            #profileBtn
            class="user"
            [class.open]="showProfileMenu"
            (click)="toggleMenu()"
            (keyup)="toggleMenu()"
            tabindex="3"
          >
            @if (userModel) {
              <div class="avatar">
                <img
                  [src]="getSafePhotoURL()"
                  [alt]="userModel.displayName || 'Profile Picture'"
                  class="img-fluid circle-mask rounded-circle"
                  title="Profile Picture"
                />
              </div>
            }
            <div class="info">
              <p
                class="name fw-bold"
                [innerText]="userModel.displayName || userModel.email"
              ></p>
              @if (userModel.displayName) {
                <p class="email" [innerText]="userModel.email"></p>
              }
              @if (userModel.role) {
                <small
                  class="options fst-italic text-capitalize"
                  [innerText]="getRoleName(userModel.role)"
                ></small>
              }
            </div>
            <div class="arrow-down">
              <i class="fa fa-angle-down" aria-hidden="true"></i>
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
            <div
              #profileMenu
              class="dropdown-menu"
              [class.active]="showProfileMenu"
            >
              <div class="account-info account-info my-4 d-block d-lg-none">
                @if (licenseLookupPending && (!mspAccount || !mspAccount.license_expiration_date)) {
                  <i class="fa-solid fa-spinner fa-spin"></i>
                }
                @if (
                  mspAccount &&
                  mspAccount.license_expiration_date &&
                  mspAccount.is_eval
                ) {
                  <p>
                    Account Expires:
                    {{
                      mspAccount.license_expiration_date * 1000
                        | date: "MMM d, y HH:mm"
                    }}
                    @if (mspAccount.is_eval) {
                      <span class="text-info">( Eval Account ) </span>
                    }
                  </p>
                  @if (!isExpiringSoon(mspAccount.license_expiration_date)) {
                    <p class="text-end">
                      <a
                        [routerLink]="['/dashboard', 'my-account']"
                        fragment="billing"
                        >Upgrade Account</a
                      >
                    </p>
                  }
                  @if (
                    isExpiringSoon(mspAccount.license_expiration_date) &&
                    remainingTime &&
                    mspAccount.license_expiration_date
                  ) {
                    <p>
                      Expires in:
                      @if (remainingTime.hours > 0) {
                        <span class="text-danger"
                          >{{ remainingTime.hours }} hours</span
                        >
                      }
                      @if (
                        remainingTime.hours > 0 && remainingTime.minutes > 0
                      ) {
                        <span class="text-danger"> and </span>
                      }
                      @if (remainingTime.minutes > 0) {
                        <span class="text-danger"
                          >{{ remainingTime.minutes }} minutes</span
                        >
                      }
                      @if (
                        remainingTime.seconds > 0 &&
                        remainingTime.hours === 0 &&
                        remainingTime.minutes === 0
                      ) {
                        <span class="text-danger">
                          and {{ remainingTime.seconds }} seconds</span
                        >
                      }
                    </p>
                    <p class="text-end">
                      <a
                        [routerLink]="['/dashboard', 'my-account']"
                        fragment="billing"
                        >Renew Now</a
                      >
                    </p>
                  }
                }
              </div>

              <!-- Multi-Tenant Company Switcher -->
              @if (hasMultipleCompanies()) {
                <div class="company-switcher-section">
                  <div class="company-switcher-header">
                    <i class="fa fa-building" aria-hidden="true"></i>
                    <span>Switch Company</span>
                  </div>
                  @if (isLoadingCompanies) {
                    <div class="company-switcher-loading">
                      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                      <span>Loading companies...</span>
                    </div>
                  }
                  @if (!isLoadingCompanies) {
                    <div class="company-switcher-list">
                      @for (company of userCompanies; track company.uid) {
                        <button
                          type="button"
                          class="company-switcher-item"
                          [class.active]="company.isCurrent"
                          [disabled]="company.isCurrent || isSwitchingCompany"
                          (click)="switchToCompany(company.uid)"
                          [aria-label]="'Switch to ' + company.name"
                        >
                          <div class="company-info">
                            <div class="company-name">
                              {{ company.name }}
                              @if (company.isCurrent) {
                                <i
                                  class="fa fa-check-circle current-indicator"
                                  aria-hidden="true"
                                ></i>
                              }
                            </div>
                            <span
                              class="company-tier-badge"
                              [ngClass]="getTierBadgeClass(company.tier)"
                            >
                              {{ getTierDisplayName(company.tier) }}
                            </span>
                          </div>
                          @if (isSwitchingCompany && !company.isCurrent) {
                            <span class="sr-only">Switching...</span>
                            <i
                              class="fa fa-spinner fa-spin"
                              aria-hidden="true"
                            ></i>
                          }
                        </button>
                      }
                    </div>
                  }
                </div>
              }

              <ul class="list-unstyled user-dropdown">
                <li>
                  <a
                    class="waves-effect text-uppercase"
                    [routerLink]="['/dashboard/my-account']"
                    routerLinkActive="active"
                    title="My Account"
                  >
                    <i class="fa fa-user"></i>
                    My Account
                  </a>
                </li>
                <li>
                  <a
                    class="waves-effect text-uppercase"
                    [routerLink]="['/dashboard/company']"
                    routerLinkActive="active"
                    title="My Company"
                  >
                    <i class="fa fa-building"></i>
                    My Company
                  </a>
                </li>
                <li>
                  <a
                    class="waves-effect text-uppercase"
                    [routerLink]="'/logout'"
                    routerLinkActive="active"
                    title="Logout"
                  >
                    <i class="fa fa-sign-out"></i>
                    Logout
                  </a>
                </li>
                @if (false) {
                  <li>
                    <!-- TODO Add this back when we have settings -->
                    <a
                      class="waves-effect waves-teal text-uppercase"
                      title="settings"
                      [routerLink]="['/dashboard', 'settings']"
                      routerLinkActive="active"
                    >
                      <i class="fa fa-cog"></i> Settings
                    </a>
                  </li>
                }
              </ul>
              <button
                type="button"
                class="btn p-0 border-0 bg-transparent d-flex justify-content-center align-items-center"
                (click)="toggleDarkMode(); $event.stopPropagation()"
                aria-label="Toggle dark mode"
              >
                <span class="theme-toggle-wrapper" [class.dark]="dark.value">
                  <span class="theme-toggle__track" aria-hidden="true">
                    <span class="theme-toggle__thumb" aria-hidden="true">
                      <i
                        class="fas"
                        [ngClass]="dark.value ? 'fa-moon' : 'fa-sun'"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </span>
                </span>
              </button>
            </div>
            <!-- /.dropdown-menu -->
          </li>
        }
        <!-- /.user -->
        <!-- <li class="button-menu-right">
            <img src="assets/images/icon/menu-right.png" alt="">
          </li> -->
        <!-- /.button-menu-right -->
      </ul>
      <!-- /.info-right -->
    </div>
  </div>
  <!-- /.navbar-top -->
</header>
<!-- /header <-->
